import {useEntitlement} from '@github-ui/copilot-chat/components/quota/EntitlementContext'
import {useQuotaBannerImpression} from '@github-ui/copilot-chat/components/quota/use-quota-banner-impression'
import {UPGRADE_FREEZE_LEARN_MORE_URL} from '@github-ui/copilot-chat/utils/copilot-chat-helpers'
import {copilotFeatureFlags} from '@github-ui/copilot-chat/utils/copilot-feature-flags'
import {sendEvent} from '@github-ui/hydro-analytics'
import {Banner, Link, LinkButton} from '@primer/react'

import styles from './FreeChatExceededBanner.module.css'

export function FreeChatExceededBanner() {
  const {plan, resetDate} = useEntitlement()
  useQuotaBannerImpression({variant: 'free_chat_exceeded', source: 'copilot-immersive-v1'})
  const descriptionText = `You have reached your free plan limit. Limit resets on ${resetDate}.`
  const showFreezeMessage = copilotFeatureFlags.upgradeFreezeEnabled

  const description = showFreezeMessage ? (
    <>
      {descriptionText} Plan upgrades are temporarily unavailable.{' '}
      <Link inline href={UPGRADE_FREEZE_LEARN_MORE_URL}>
        Read more
      </Link>
    </>
  ) : (
    descriptionText
  )

  const primaryAction = showFreezeMessage ? undefined : (
    <LinkButton
      as="a"
      href="https://github.com/features/copilot#pricing"
      onClick={() => {
        sendEvent('dotcom_chat.activate', {
          target: 'QUOTA_BANNER_EXCEEDED',
          action: 'upgrade',
          mode: 'immersive',
          tokenBasedBillingEnabled: false,
          plan,
        })
      }}
    >
      Upgrade
    </LinkButton>
  )

  return (
    <div className={styles.container}>
      <Banner
        variant="upsell"
        title="Limit reached"
        description={description}
        hideTitle
        primaryAction={primaryAction}
      />
    </div>
  )
}
